// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6477":"css/admin-app.6996","9576":"css/app.6996"}[chunkId] + ".css";
};